export const structure = {
  map: {},
  tree: [],
  fields: {},
  isSelectDisabled: false,
  // zones create/edit
  isSimpleGeom: false,
  layerNames: {},
  layerTypes: {},
  activeLayers: [],
  selectedModelId: null,
  filteredObjectsCount: {},
  fullDataSetLoaded: {},
  objectsCount: {},
  // pt
  activeTsysCode: null,
  activeLineRouteItems: [],
  ptActiveLayers: [],
  activeRoutes: {},
  lanesEditorObjects: []
}

export const nonClearableFields = ['layerNames', 'map', 'activeLayers']
